var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationSearching(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3.06C17.67 3.52 20.98 6.83 21.44 11H23.5V13H21.44C20.98 17.17 17.67 20.48 13.5 20.94V23H11.5V20.94C7.33 20.48 4.02 17.17 3.56 13H1.5V11H3.56C4.02 6.83 7.33 3.52 11.5 3.06V1H13.5V3.06ZM5.5 12C5.5 15.87 8.63 19 12.5 19C16.37 19 19.5 15.87 19.5 12C19.5 8.13 16.37 5 12.5 5C8.63 5 5.5 8.13 5.5 12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSearching);
export default __webpack_public_path__ + "static/media/location-searching.cb7aed7d9ef6e088dd73befe768b3220.svg";
export { ForwardRef as ReactComponent };